import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { RowJustifyStartFlex } from "../Containers";
import { useEffect, useState } from "react";
import { FilterFactory } from "./FilterFactory";
import _ from "lodash";

export default function Filter({ model, filter, filterHandler }) {

    const [addFilterAnchor, setAddFilterAnchor] = useState();
    const [openFilterMenu, setOpenFilterMenu] = useState(false);
    const [filterComponents, setFilterComponents] = useState(() => {
        if (!_.isEmpty(model) && !_.isEmpty(filter)) {
            return model.filter(e => e.key && filter[e.key]).map(e => ({ ...e, [e.key]: filter[e.key] }));
        }
        return [];
    });

    return (<RowJustifyStartFlex flexWrap={"wrap"} gap={1} padding={0.5}>
        <Typography>
            Filters
        </Typography>
        {filterComponents && filterComponents.map(f => {
            const Component = FilterFactory[f.type];
            const filterDef = model.find(d => d.key === f.key);
            const getValueHandler = () => {
                const value = f[filterDef.key];
                return value ? value : '';
            };
            const deleteHandler = () => {
                setFilterComponents(prev => [...prev ? prev.filter(v => v.key !== f.key) : []]);
            };
            return <Component key={f.key} field={f} getValueHandler={getValueHandler} valueHandler={setFilterComponents} deleteHandler={deleteHandler} anchor={addFilterAnchor} />
        })}
        <Button variant="indigo-100-text-button" onClick={(e) => {
            setAddFilterAnchor(e.currentTarget);
            setOpenFilterMenu(true);
        }}>
            Add Filter
        </Button>
        <Button variant="indigo-100-text-button" onClick={() => {
            const newFilter = {};
            filterComponents.forEach(f => newFilter[f.key] = f[f.key]);
            filterHandler(newFilter);
        }}>
            Apply Filters
        </Button>
        <Menu open={openFilterMenu} anchorEl={addFilterAnchor} onClose={() => setOpenFilterMenu(false)}>
            {model && model.map(e => <MenuItem key={e.key} onClick={() => {
                if (filterComponents && !filterComponents.some(f => f.key === e.key)) {
                    setFilterComponents([...filterComponents ? filterComponents : [], { ...e }]);
                }
                setOpenFilterMenu(false);
            }}>{e._name}</MenuItem>)}
        </Menu>
    </RowJustifyStartFlex>);
}